import { Button } from '@/components/common';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon } from '@heroicons/react/24/outline';
import { cn } from '@/utils';

interface WizardNavigationProps {
  isFirst: boolean;
  isLast: boolean;
  isSubmitting?: boolean;
  canGoNext?: boolean;
  canGoPrevious?: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onComplete?: () => void;
  previousLabel?: string;
  nextLabel?: string;
  completeLabel?: string;
  className?: string;
}

export function WizardNavigation({
  isFirst,
  isLast,
  isSubmitting,
  canGoNext = true,
  canGoPrevious = true,
  onPrevious,
  onNext,
  onComplete,
  previousLabel = 'Previous',
  nextLabel = 'Next',
  completeLabel = 'Complete',
  className,
}: WizardNavigationProps) {
  return (
    <div className={cn('flex items-center justify-between pt-6 border-t border-gray-200 dark:border-gray-700 mt-6', className)}>
      <div>
        {!isFirst && (
          <Button
            variant="outline"
            onClick={onPrevious}
            disabled={!canGoPrevious || isSubmitting}
            leftIcon={<ArrowLeftIcon className="w-4 h-4" />}
          >
            {previousLabel}
          </Button>
        )}
      </div>

      <div>
        {isLast ? (
          <Button
            variant="primary"
            onClick={onComplete || onNext}
            isLoading={isSubmitting}
            // `canGoNext` defaults to true, so this is a no-op for any caller
            // that never disables it on its terminal step (Motor/Life's
            // "review" step keeps an empty required-fields list there). The
            // Health branch (Task 2.7) is the first to actually gate this —
            // its "Calculate Premium" CTA must stay disabled until every
            // mandatory field across the whole flow validates.
            disabled={isSubmitting || !canGoNext}
            leftIcon={!isSubmitting ? <CheckIcon className="w-4 h-4" /> : undefined}
          >
            {completeLabel}
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={onNext}
            disabled={!canGoNext || isSubmitting}
            rightIcon={<ArrowRightIcon className="w-4 h-4" />}
          >
            {nextLabel}
          </Button>
        )}
      </div>
    </div>
  );
}
